import { Link } from "react-router";
import { UserNav } from "./UserNav";
import { NotificationPanel } from "./Notifications";
import { HelpMenu } from "./HelpMenu";
import Logo from "@/assets/logo.svg?react";

export const Header = () => {
  return (
    <header className="supports-backdrop-blur:bg-background/60 bg-background/95 backdrop-blur-sm border-b border-border/60">
      <nav className="h-14 flex items-center justify-between px-4 lg:px-5">
        <Link to="../" className="shrink-0">
          <Logo width={99} height={27} title="notiflows" />
        </Link>
        <div className="flex items-center gap-1.5">
          <HelpMenu />
          <NotificationPanel />
          <UserNav />
        </div>
      </nav>
    </header>
  );
};
